module.exports = __webpack_public_path__ + "static/img/login-background.4d646a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-background.jpg
// module id = YPQl
// module chunks = 1